import "./resFilterOptions.scss";
import { reservationFilterOptions } from "features/reservations/reservationFiltersConstant";
import MultiSelect from "features/reservations/MultiSelect";
import ResSingleSelect from "features/reservations/ResSingleSelect";
import { useEffect, useRef, useState } from "react";
import FilterMenu from "components/FilterMenu";

const FilterOptions = ({ selectedFilters, onFiltersChange, resetPage }) => {
    const [filters, setFilters] = useState({
        idPlatForm: [],
        bookingMonth: new Date().toISOString().slice(0, 7),
        checkOutMonth: '',
        bookingStatus: [],
        billingMode: [],
    });

    useEffect(() => {
        onFiltersChange(filters);
        resetPage(0);
    }, []);

    const timeoutRef = useRef(null);

    const handleFiltersChange = (value, id) => {
        const updatedFilters = {
            ...filters,
            [id]: value,
        };

        setFilters(updatedFilters); // UI updates immediately

        // Clear previous timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Set a new delayed API trigger
        timeoutRef.current = setTimeout(() => {
            onFiltersChange(updatedFilters); // API call
            resetPage(0); // Reset pagination
        }, 500); // Wait 500ms after last input
    };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <div>
            <div className="form-button-container">
                <div className="formGrid">
                    <div className="filter-field-container">
                        {reservationFilterOptions.map((field) => (
                            <div className="form-grid-item" key={field.id}>
                                <div className="mul-item">
                                    <div className="mul-form-label">{field.label}</div>
                                    {field.multi ? (
                                        <>
                                        <FilterMenu
                                            options={field.options.map(option => ({...option, isSelected: filters[field.id].includes(option.id) }))}
                                            optionsDesignation={field.designationOptions?.map(option => ({...option, isSelected: filters[field.id].includes(option.id) }))}
                                            optionsOtherAds={field.otherAdsOptions?.map(option => ({...option, isSelected: filters[field.id].includes(option.id) }))}
                                            filterType={field.label}
                                            onApply={(selectedOptions) =>
                                                handleFiltersChange(selectedOptions.map(option => option.id ?? option.value), field.id)
                                            }
                                            label={field.label}
                                            placeholder={field.placeholder}
                                        />
                                        </>
                                    ) : (
                                        <ResSingleSelect
                                            value={field.id === 'bookingMonth' ? selectedFilters.bookingMonth : undefined}
                                            options={field.options}
                                            onChange={(event) =>
                                                handleFiltersChange(event.target.value, field.id)
                                            }
                                            sx={{
                                                backgroundColor: "white",
                                                width: field.id === 'billingMode' ? "250px" : "190px",
                                            }}
                                            placeholder={field.placeholder}
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterOptions;